<template>
  <div class="chart-container" style="display:flex; align-items:flex-start;">
    <Pie
      :data="pieData"
      :options="pieOptions"
      :redraw="true"
    />
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import axios from '@/services/axios'
import { Pie } from 'vue-chartjs'
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js'

Chart.register(ArcElement, Tooltip, Legend)

const props = defineProps({
  dataInicio: String,
  dataFim:    String
})

const pieData = ref({ labels: [], datasets: [{ data: [], backgroundColor: [] }] })

const pieOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: true,
      text: 'Proporção de Matrículas (Anual)',
      align: 'start'
    },
    tooltip: {
      callbacks: {
        title()   { return `Ano: ${props.dataInicio.split('-')[0]}` },
        label(ctx){ return `${ctx.label}: ${ctx.parsed.toLocaleString()}` },
        footer(ctxs){
          const total = ctxs[0].chart.data.datasets[0].data
                       .reduce((s,v)=>s+v,0)
          return `Total: ${total}`
        }
      },
      footerFont: { weight: 'bold' }
    },
    legend: { position: 'right', align: 'center' }
  }
}

async function fetchPie() {
  try {
    const { data } = await axios.get(
      '/gestao/graficos/individuais/matriculas-anual',
      { params: { dataInicio: props.dataInicio, dataFim: props.dataFim } }
    )
    pieData.value = {
      labels: data.labels,
      datasets: [{
        data: data.values,
        backgroundColor: ['#1ABC9C','#F1948A']
      }]
    }
  } catch (e) {
    console.error('Erro em MatriculasAnualPie:', e)
  }
}

onMounted(fetchPie)
watch(() => [props.dataInicio, props.dataFim], fetchPie)
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 300px;
}
@media(min-width:768px){
  .chart-container { height: 400px; }
}
</style>
